module.exports = __webpack_public_path__ + "images/863aa38d6f8212156b2d5f4c29b34646-illu_call.png";